'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isFutureDate = require('./is-future-date.js');
var index = require('./constants/index.js');

function isLessThanOneHourAgo(date, now = new Date()) {
  return !isFutureDate.isFutureDate(date, now) && now.getTime() - date.getTime() < index.TimeUnit.Hour;
}

exports.isLessThanOneHourAgo = isLessThanOneHourAgo;
